module.exports = require("universal-router");


//////////////////
// WEBPACK FOOTER
// external "universal-router"
// module id = 29
// module chunks = 0